<script setup>

    import {useAuctionStore} from "../../../stores/auctions";
    import {ref} from "vue";

    const store = useAuctionStore();
    const props = defineProps(['auctions', 'userId']);

    const dealBid = [];
    const dealBidMessage = ref('');

    store.updateAuction()

    setInterval(() => store.updateAuction(), 30000);

    // Join auctions channel
    Echo.channel('auctions')
        .listen('AuctionUpdated', (event) => {
            store.updateAuction();
        });

    const submitBid = (deal, amount) => {

        axios.post(route('deal.bid.store', deal, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }), {amount: amount}).then(response => {

            dealBidMessage.value = response.data.message;
            store.updateAuction();
            dealBid[deal.id] = null;
        });
    }

    const buyNow = (deal) => {
        if (confirm('Are you sure you wish to buy now and end the auction?')) {
            axios.post(route('deal.auction.buy-now', deal, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })).then(response => {
                dealBidMessage.value = response.data.message;
                store.updateAuction();
                dealBid[deal.id] = null;
            });
        }
    }


    window.addEventListener("focus", function() {
        store.updateAuction();
    });

</script>

<template>
    <div>


        <div v-if="dealBidMessage" class="w-full flex">
            <div class="mx-auto py-4">
                {{ dealBidMessage }}
            </div>
        </div>
    <table class="min-w-full divide-y divide-gray-800 border rounded-md">
        <thead class="bg-white text-xs text-gray-800">
        <tr>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Auction ID</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Title</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Quantity</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Categories</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Remaining Time</th>
<!--            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Unfollow</th>-->
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Your Bid</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Highest Bid</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Status</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Minimum Next Bid</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Bid</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider">Bid Type</th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider"></th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider"></th>
            <th class="px-6 py-4 text-left font-medium uppercase tracking-wider"></th>
<!--            <th class="px-6 py-2 text-left font-medium uppercase tracking-wider">Quick Bid</th>-->
            <th class="px-6 py-2 text-left font-medium uppercase tracking-wider">View</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-gray-800 text-gray-800 text-sm ">
<!--        <span> <td>{{ store.auctions }}</td></span>-->
        <tr :class="line.deal.latest_auction.winning_user_id === userId ? 'bg-green-200' : 'bg-gray-100'" v-for="line in store.auctions">

            <td class="px-6 py-2">
                #{{ line.deal.latest_auction.id }}
            </td>

            <td class="px-6">
                {{ line.deal.subtitle }}
            </td>

            <td class="px-2">{{ line.deal.quantity }}</td>

            <td class="px-6 py-2">
                {{ line.deal.categories.join(' / ') }}
            </td>


            <td class="px-6">
                <timer-end :starting-end-time="line.ending_timestamp" :full-string="true"></timer-end>
            </td>

<!--            <td class="px-6">-->
<!--                <a :href="route('deal.unfollow', {deal: line.deal})">Unfollow</a>-->
<!--            </td>-->

            <td class="px-6">
                {{ $filters.formatNumber(line.user_bid) }} {{ line.deal.currency === '-' ? 'GBP' : line.deal.currency }}
            </td>

            <td class="px-6" v-if="line.deal.latest_auction.time_remaining_seconds > 0">
                {{ $filters.formatNumber(line.winning_bid) }} {{ line.deal.currency === '-' ? 'GBP' : line.deal.currency }}
            </td>
            <td class="px-6" v-else>-</td>

            <td class="px-6" v-if="!line.deal.latest_auction.has_started">
                <span v-if="line.deal.latest_auction.winning_user_id === userId">Won</span>
                <span v-else>Lost</span>
            </td>
            <td class="px-6" v-else>
                <span v-if="line.deal.latest_auction.winning_user_id === userId">Winning</span>
                <span v-else>Losing</span>
            </td>

            <td class="px-6" v-if="line.deal.latest_auction.time_remaining_seconds > 0">
                {{ $filters.formatNumber(line.next_minimum_bid) }} {{ line.deal.currency === '-' ? 'GBP' : line.deal.currency }}
            </td>
            <td class="px-6" v-else>-</td>

            <td class="px-6 py-2" v-if="line.deal.latest_auction.has_started">
                <input type="number" name="amount" class="text-black mr-3 rounded-md border border-transparent bg-opacity-90 bg-white py-3 text-sm font-medium" v-model="dealBid[line.deal.id]">
            </td>
            <td v-else></td>

            <td class="px-12">{{ line.deal.latest_auction.type }}</td>

            <td v-if="line.deal.latest_auction.has_started">
                <button type="button" class="rounded-md items-center justify-center border border-transparent bg-opacity-90 bg-fwdarkpurple mx-1 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-fwdarkpurple focus:ring-offset-2 focus:ring-offset-gray-50" v-on:click="submitBid(line.deal, dealBid[line.deal.id])">Place Bid</button>
            </td>
            <td v-else></td>
            <td v-if="line.deal.latest_auction.has_started">
                <button type="button" class="rounded-md items-center justify-center border border-transparent bg-opacity-90 bg-fwdarkpurple mx-1 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-fwdarkpurple focus:ring-offset-2 focus:ring-offset-gray-50" v-on:click="submitBid(line.deal, line.next_minimum_bid)">Bid {{ $filters.formatNumber(line.next_minimum_bid) }} {{ line.deal.currency }}</button>
            </td>
            <td v-else></td>
            <td v-if="line.deal.latest_auction.has_started">
                <button v-if="line.buy_now_price > 0 && line.buy_now_price > line.winning_bid" type="button" class="rounded-md items-center justify-center border border-transparent bg-opacity-90 bg-fwdarkpurple mx-1 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-fwdarkpurple focus:ring-offset-2 focus:ring-offset-gray-50" v-on:click="buyNow(line.deal)">Buy Now ({{ $filters.formatNumber(line.buy_now_price)}} {{ line.deal.currency }})</button>
            </td>
            <td class="px-6" v-else-if="line.deal.latest_auction.time_remaining_seconds > 0">
                Auction has not started
            </td>
            <td class="px-6" v-else>
                Auction has Ended
            </td>

            <td class="px-6">
                <a :href="route('deal.show', {deal:line.deal})" class="hover:underline font-bold cursor-pointer">View</a>
            </td>
        </tr>
        </tbody>
    </table>
    </div>
</template>

<style scoped>

</style>
